import i18n from "@/i18n"
export default {
  areaFields: [
    {key: "hokkaido", value: i18n.tc("metaDataSite.options.areaFields.hokkaido")},
    {key: "tohoku", value: i18n.tc("metaDataSite.options.areaFields.tohoku")},
    {key: "tokyo", value: i18n.tc("metaDataSite.options.areaFields.tokyo")},
    {key: "kanto", value: i18n.tc("metaDataSite.options.areaFields.kanto")},
    {key: "chubu", value: i18n.tc("metaDataSite.options.areaFields.chubu")},
    {key: "kinki", value: i18n.tc("metaDataSite.options.areaFields.kinki")},
    {key: "hokuriku", value: i18n.tc("metaDataSite.options.areaFields.hokuriku")},
    {key: "china", value: i18n.tc("metaDataSite.options.areaFields.china")},
    {key: "shikoku", value: i18n.tc("metaDataSite.options.areaFields.shikoku")},
    {key: "kyushu", value: i18n.tc("metaDataSite.options.areaFields.kyushu")},
    {key: "okinawa", value: i18n.tc("metaDataSite.options.areaFields.okinawa")},
  ],
  kendoTypeFields: [
    {key: "civilEngineering", value: i18n.tc("metaDataSite.options.kendoTypeFields.civilEngineering")},
    {key: "architecture", value: i18n.tc("metaDataSite.options.kendoTypeFields.architecture")},
  ],
  civilEngineeringKohshuTypes: [
    {key: "tunnel", value: i18n.tc("metaDataSite.options.civilEngineeringKohshuTypes.tunnel")},
    {key: "shield", value: i18n.tc("metaDataSite.options.civilEngineeringKohshuTypes.shield")},
    {key: "dam", value: i18n.tc("metaDataSite.options.civilEngineeringKohshuTypes.dam")},
    {key: "bridge", value: i18n.tc("metaDataSite.options.civilEngineeringKohshuTypes.bridge")},
    {key: "oceanOrHarbor", value: i18n.tc("metaDataSite.options.civilEngineeringKohshuTypes.oceanOrHarbor")},
    {key: "earthworkOrCreation", value: i18n.tc("metaDataSite.options.civilEngineeringKohshuTypes.earthworkOrCreation")},
    {key: "roadOrRailway", value: i18n.tc("metaDataSite.options.civilEngineeringKohshuTypes.roadOrRailway")},
    {key: "river", value: i18n.tc("metaDataSite.options.civilEngineeringKohshuTypes.river")},
    {key: "subway", value: i18n.tc("metaDataSite.options.civilEngineeringKohshuTypes.subway")},
    {key: "raterAndSewage", value: i18n.tc("metaDataSite.options.civilEngineeringKohshuTypes.raterAndSewage")},
    {key: "civilEngineeringAndOthers", value: i18n.tc("metaDataSite.options.civilEngineeringKohshuTypes.civilEngineeringAndOthers")},
  ],
  civilEngineeringOfArchitectures: [
    {key: "civilEngineering", value: i18n.tc("metaDataSite.options.civilEngineeringOfArchitectures.civilEngineering")},
  ],
  architectureKohshuTypes: [
    {key: "theOffice", value: i18n.tc("metaDataSite.options.architectureKohshuTypes.theOffice")},
    {key: "store", value: i18n.tc("metaDataSite.options.architectureKohshuTypes.store")},
    {key: "hotel", value: i18n.tc("metaDataSite.options.architectureKohshuTypes.hotel")},
    {key: "hospital", value: i18n.tc("metaDataSite.options.architectureKohshuTypes.hospital")},
    {key: "school", value: i18n.tc("metaDataSite.options.architectureKohshuTypes.school")},
    {key: "housingComplex", value: i18n.tc("metaDataSite.options.architectureKohshuTypes.housingComplex")},
    {key: "productionFacility", value: i18n.tc("metaDataSite.options.architectureKohshuTypes.productionFacility")},
    {key: "mixedUse", value: i18n.tc("metaDataSite.options.architectureKohshuTypes.mixedUse")},
    {key: "architectureAndOthers", value: i18n.tc("metaDataSite.options.architectureKohshuTypes.architectureAndOthers")},
  ],
  architectureOfArchitectures: [
    {key: "RCConstruction", value: i18n.tc("metaDataSite.options.architectureOfArchitectures.RCConstruction")},
    {key: "SRCConstruction", value: i18n.tc("metaDataSite.options.architectureOfArchitectures.SRCConstruction")},
    {key: "SStructure", value: i18n.tc("metaDataSite.options.architectureOfArchitectures.SStructure")},
    {key: "wooden", value: i18n.tc("metaDataSite.options.architectureOfArchitectures.wooden")},
    {key: "other", value: i18n.tc("metaDataSite.options.architectureOfArchitectures.other")},
  ]
}